export const ERP_FORMAT_CONFIG = {
  DECIMAL: {
    QUANTITY: 2,
    RATE: 2,
    AMOUNT: 2,
    PERCENTAGE: 2,
  },

  DATE: {
    DISPLAY: "DD-MMM-YYYY",
    DISPLAY_DATETIME: "DD-MMM-YYYY HH:mm",
    API_DATE: "YYYY-MM-DD",
    API_DATETIME: "YYYY-MM-DD HH:mm:ss",
  },

  CURRENCY: {
    SYMBOL: "₹",
    CODE: "INR",
  },
};